module.exports = require('./components/cms');
